<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2020-05-09 10:17:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-23 15:55:53
 * @FilePath: /goldenSalesMobile/src/components/JsBarcode/index.vue
 * @Description: 分享提示蒙层
-->
<template>
  <van-overlay :show="showShare" @click="handleCloseOverlay">
    <div class="guide_share_con" @click.stop>
      <span>点击右上角，就可以转发给朋友喽</span>
      <div class="share_img_con">
        <img class="full_img" src="@/assets/images/guideShareIcon.png" alt="" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: "shareOverlay",
  props: {},
  data() {
    return {
      showShare: false,
    };
  },
  mounted() {},
  methods: {
    handleSetShowShare() {
      this.showShare = !this.showShare;
    },
    handleCloseOverlay() {
      console.log(99999999);
      this.showShare = false;
      this.$emit("handleGetList");
    },
  },
};
</script>
<style lang="scss" scoped>
.guide_share_con {
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  span {
    color: #fff;
    font-size: 28px;
    padding: 20px 0;
  }
  .share_img_con {
    width: 106px;
    height: 124px;
  }
}
</style>
